// extracted by mini-css-extract-plugin
export default {"card":"ServiceCard_card__M-WS6","image":"ServiceCard_image__JUZ00","title":"ServiceCard_title__EnvI8","description":"ServiceCard_description__7pGft"};